module.exports = __webpack_public_path__ + "static/media/offline.fd927235.ico";